import React from 'react';
import { DndProvider } from 'react-dnd';
import { BaseSocketProvider } from '@src/core/socket';
import { HTML5Backend } from 'react-dnd-html5-backend';
import WeatherProvider from '@src/core/socket/weather';
import { ProvidersProps } from './types';
import { DroneProvider } from '@src/core/features';
import { UnitsProvider } from '@src/core/features/settings';

const AnalystProviders: React.FC<ProvidersProps> = ({ children }) => (
  <WeatherProvider>
    <DndProvider backend={HTML5Backend}>
      <BaseSocketProvider>
        <UnitsProvider>
          <DroneProvider>
            {children}
          </DroneProvider>
        </UnitsProvider>
      </BaseSocketProvider>
    </DndProvider>
  </WeatherProvider>
);

export default AnalystProviders;